// Asset URL builder — all images served from OVH
const B = 'https://khansayazidi.tn/assets';
const u = (path) => `${B}/${path}`;

// Helper: build product object with multiple images
const p = (folder, files) => files.map(f => u(`${folder}/${f}`));

const IMAGES = {
  logo: u('logo cuivre.webp'),
  logoBlanc: u('Khansa_logo_blanc.webp'),
  logoFallback: 'https://static.wixstatic.com/media/90a441_093d510781434814a80def856934a0b9~mv2.jpg',
  //designer: 'https://static.wixstatic.com/media/6b8d8a_fb38ee645be94702bf980acca8ecb987~mv2.jpg',
  designer: u('1779036829063.webp'),
  garantie: p('Garantie', ['IMG_4233.webp','IMG_4308.webp','IMG_4421.webp']),
  entretien: p('Produit d_entretien', ['IMG_2924.webp','IMG_2953.webp','IMG_2963.webp']),
  heroStandalone: u('1779036829063.webp'),
  video: u('khansa-yazidi-02.mp4'),
  devis: u('IMG_4174.webp'),

};

export default IMAGES;
export { B, u, p };
